enum ExceptionTypes {
  MultipleCheckOutException = "MultipleCheckOutException",
}

export default ExceptionTypes;
